import React, { useEffect, useState } from "react";
import close from "../../assets/images/deleteaction.svg";
import closebtn from "../../assets/images/close.svg";

import { Col, Dropdown, Form, Nav, Row, Tab } from "react-bootstrap";
import profilepic1 from "../../assets/images/cate1.png";
import { API_URL } from "../../services/APIRoute";
import { apiCall } from "../../services/AxiosService";
import { apiResponse } from "../../services/APIResponse";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteModal from "../../Modals/DeleteModal";
import profileicon from "../../assets/images/dummy-profile-pic.jpg";
import {
    WorkTeamGetTeamList,
    WorkTeamInsert,
    WorkTeamUpdate,
} from "../../services/ReduxTookit/Slice/WorkflowTeamRedux";
import { RoleGetList } from "../../services/ReduxTookit/Slice/RoleRedux";
import Loader, { LoaderType } from "./Loader";
import { commonservices } from "../../services/CommonServices";

function WorflowContactList({
    isViewMode,
    handleshowPopup,
    fetchContactData,
    id,
}) {
    // let { id } = useParams();
    const dispatch = useDispatch();
    let Userdata = useSelector((state) => state.userinfo.UserInfo);
    const [DeleteContactModalShow, setDeleteContactModalShow] = useState(false);

    const [roleType, setRoleType] = useState([]);
    const [requiredData, setRequiredData] = useState(null);

    const [DeletePayload, setDeletePayload] = useState({
        id: "",
    });
    const [contactData, setContactData] = useState([]);


    const [workFlowContactListLoadng, setWorkFlowContactListLoadng] =
        useState(false);

    // const fnInputChange = (a, b, type, teamid, subContactID = 0) => {
    //   if (type === "put") {
    //     const updatedUsers = contactData.map((user) =>
    //       user.userid === b
    //         ? {
    //             ...user,
    //             workflowroleid: a,
    //           }
    //         : user
    //     );
    //     setContactData(updatedUsers);

    //     functionUpdateContacts(teamid, a);
    //   }
    //   if (type === "add") {
    //     const updatedUsers = contactData.map((user) =>
    //       user.userid === b
    //         ? {
    //             ...user,
    //             workflowroleid: a,
    //           }
    //         : user
    //     );
    //     setContactData(updatedUsers);

    //     functionAddContacts(b, a, subContactID);
    //   }
    //   if (type === "delete") {
    //     const updatedUsers = contactData.map((user) =>
    //       user.userid === b
    //         ? {
    //             ...user,
    //             workflowroleid: null,
    //           }
    //         : user
    //     );
    //     setContactData(updatedUsers);
    //     functionDeleteContacts(teamid, a, b);
    //   }
    // };

    // const functionUpdateContacts = async (teamid, roleid) => {
    //   let body = {
    //     workflowteamid: parseInt(teamid),
    //     workflowroleid: parseInt(roleid),
    //   };
    //   // let ResponseData = await apiCall(
    //   //   {
    //   //     method: "PUT",
    //   //     url: API_URL.BASEURL + API_URL.WORKFLOWTEAM.UPDATE,
    //   //     body: body,
    //   //   },
    //   //   true
    //   // );
    //   // let response = apiResponse(false, ResponseData);
    //   dispatch(WorkTeamUpdate(body))?.then((response) => {
    //     if (response?.payload?.isValidate) {
    //       fetchData();
    //     }
    //   });
    // };

    // const functionAddContacts = (userid, roleid, subContactID) => {
    //   let body = {
    //     userid: userid,
    //     subscriberid: Userdata?.subscriberid,
    //     subscriberscontactid: subContactID,
    //     workflowid: parseInt(id),
    //     workflowroleid: parseInt(roleid),
    //   };

    //   dispatch(WorkTeamInsert(body))?.then((res) => {
    //     if (res?.payload?.isValidate) {
    //       // setRoleType(response?.data?.data?.dataList1);
    //       // toast.success(res?.payload?.data?.message);
    //       // fetchData();
    //     }
    //   });
    // };

    // const functionDeleteContacts = async (teamid, a, b) => {
    //   let body = {
    //     id: teamid,
    //   };

    //   dispatch(WorkTeamDelete(body))?.then((res) => {
    //     if (res?.payload?.isValidate) {
    //       // toast.success(res?.payload?.data?.message);
    //       // fetchData();
    //     }
    //     if (!res?.payload?.isValidate) {
    //       const updatedUsers = contactData.map((user) =>
    //         user.userid === b
    //           ? {
    //               ...user,
    //               workflowroleid: a,
    //             }
    //           : user
    //       );
    //       setContactData(updatedUsers);
    //     }
    //   });

    //   // let body = {
    //   //   id: teamid,
    //   // };
    //   // let ResponseData = await apiCall(
    //   //   {
    //   //     method: "POST",
    //   //     url: API_URL.BASEURL + API_URL.WORKFLOWTEAM.DELETE,
    //   //     body: body,
    //   //   },
    //   //   true
    //   // );
    //   // let response = apiResponse(false, ResponseData);

    //   // if (response?.isValidate) {
    //   //   // setRoleType(response?.data?.data?.dataList1);
    //   //   toast.success(response?.data?.message);
    //   //   fetchData();
    //   // }

    //   // if (!response?.isValidate) {
    //   //   // setRoleType(null);
    //   // }
    //   // setDeleteContactModalShow(true);
    //   // setDeletePayload({
    //   //   ...DeletePayload,
    //   //   id: teamid,
    //   // });
    // };

    const getRoleByType = async () => {
        dispatch(RoleGetList())?.then((res) => {
            if (res?.payload?.isValidate) {
                setRoleType(res?.payload?.data?.data?.dataList1);
            }

            if (!res?.payload?.isValidate) {
                setRoleType(null);
            }
        });
    };

    const fetchData = async () => {
        setWorkFlowContactListLoadng(true);
        if (DeleteContactModalShow) {
            fetchContactData(id);
        }
        // if (
        //   Userdata?.associationtype === "Subscribers" &&
        //   Userdata?.isorganization
        // ) {
        // setIsWorkFlowIsRunning(true);
        let body = {
            subscriberid: 0,
            workflowid: parseInt(id),
        };
        try {
            // let resData = await apiCall(
            //   {
            //     method: "POST",
            //     url: API_URL.BASEURL + API_URL.WORKFLOWTEAM.GET_TEAM_LIST,
            //     body: body,
            //   },
            //   true
            // );
            // let res = apiResponse(false, resData);
            dispatch(WorkTeamGetTeamList(body))?.then((res) => {
                if (res?.payload?.isValidate) {
                    setContactData([...res?.payload?.data?.data]);
                    setWorkFlowContactListLoadng(false);
                }
            });
            // if (res?.isValidate) {
            //   setContactData(res?.data?.data);
            // }
        } catch (error) {
            setWorkFlowContactListLoadng(false);
            // setIsWorkFlowIsRunning(false);
        }
        // }
    };

    useEffect(() => {
        getRoleByType();
        fetchData();
    }, [id]);

    const handleAddContact = (Contact, ContactRoles) => {
        const updatedUsers = contactData.map((user) =>
            user.userid === Contact.userid
                ? {
                    ...user,
                    workflowroleid: ContactRoles?.roleid,
                    rolename: ContactRoles?.rolename,
                }
                : user
        );
        setContactData(updatedUsers);

        let body = {
            userid: Contact.userid,
            subscriberid: Userdata?.subscriberid,
            subscriberscontactid: Contact.subscriberscontactid,
            workflowid: parseInt(id),
            workflowroleid: ContactRoles?.roleid,
        };

        dispatch(WorkTeamInsert(body))?.then((res) => {
            if (res?.payload?.isValidate) {
                const updatedUsers = contactData.map((user) =>
                    user.userid === Contact.userid
                        ? {
                            ...user,
                            workflowroleid: ContactRoles?.roleid,
                            rolename: ContactRoles?.rolename,
                            workflowteamid: res?.payload?.data?.data?.workflowteamid,
                        }
                        : user
                );
                setContactData(updatedUsers);
                // toast.success(res?.payload?.data?.message);
                // fetchData();
            }
        });
    };

    const handleDeleteContact = (Contact) => {
        // const updatedUsers = contactData.map((user) =>
        //   user.userid === Contact?.userid
        //     ? {
        //         ...user,
        //         workflowroleid: null,
        //       }
        //     : user
        // );
        // setContactData(updatedUsers);

        // let body = {
        //   id: Contact.workflowteamid,
        // };

        // dispatch(WorkTeamDelete(body))?.then((res) => {
        //   if (res?.payload?.isValidate) {
        //     // toast.success(res?.payload?.data?.message);
        //     // fetchData();
        //   }
        //   // if (!res?.payload?.isValidate) {
        //   //   const updatedUsers = contactData.map((user) =>
        //   //     user.userid === Contact?.userid
        //   //       ? {
        //   //           ...user,
        //   //           workflowroleid: Contact.workflowroleid,
        //   //         }
        //   //       : user
        //   //   );
        //   //   setContactData(updatedUsers);
        //   // }
        // });

        // const updatedUsers = contactData.map((user) =>
        //   user.userid === Contact?.userid
        //     ? {
        //         ...user,
        //         workflowroleid: null,
        //       }
        //     : user
        // );
        // setContactData(updatedUsers);

        setDeleteContactModalShow(true);
        setRequiredData(Contact?.userid);
        setDeletePayload({
            ...DeletePayload,
            id: Contact.workflowteamid,
        });
    };

    const handleUpdateContact = (Contact, ContactRoles) => {
        const updatedUsers = contactData.map((user) => {
            if (user.userid === Contact?.userid) {
                return {
                    ...user,
                    workflowroleid: Contact?.workflowroleid,
                    rolename: ContactRoles?.rolename,
                };
            } else {
                return user;
            }
        });
        setContactData(updatedUsers);

        let body = {
            workflowteamid: parseInt(Contact.workflowteamid),
            workflowroleid: parseInt(ContactRoles.roleid),
        };

        dispatch(WorkTeamUpdate(body))?.then((response) => {
            if (response?.payload?.isValidate) {
                // toast.success(response?.payload?.data?.message);
                // fetchData();
            }
        });
    };

    return (
        <Tab.Container
            id="left-tabs-example"
            defaultActiveKey="first"
            className="underlined-tabing"
            onHide={handleshowPopup}
        >
            <div className="schedular-popup add-project-popup contact-detail-in-flow-page-wrapper workflowdelete-contect">
                <>
                    <div className="popup-title-close-main">
                        <p>
                            Members {" "}
                            <span>
                                ({
                                    contactData?.filter((item) => item?.workflowroleid !== null)
                                        ?.length
                                })
                            </span>

                        </p>
                        <img
                            src={closebtn}
                            alt="close"
                            id="description"
                            className="cursor-pointer"
                            onClick={(e) => {
                                handleshowPopup(e);
                            }}
                        />
                    </div>
                    {!workFlowContactListLoadng ? (
                        <>
                            <div>
                                {contactData.length > 0 &&
                                    contactData?.map((item, index) => {
                                        return (
                                            <>
                                                {item?.workflowroleid && (
                                                    <div className="d-flex align-items-center justify-content-between contact-detail-in-flow-page-inner">
                                                        <div className="contact-detail-in-flow-page">
                                                            <div className="contact-detail-in-flow-page-img">
                                                                <img
                                                                    src={item?.profilepicurl || profileicon}
                                                                    alt={item?.firstname}
                                                                    title={item?.firstname}
                                                                    key={index}
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src = profileicon;
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="contact-detail-in-flow-page-detail">
                                                                <h5
                                                                    title={item?.firstname + " " + item?.lastname}
                                                                >
                                                                    {commonservices.truncateText(
                                                                        item?.firstname + " " + item?.lastname,
                                                                        20
                                                                    )}
                                                                </h5>

                                                                <div>
                                                                    <Dropdown className="public-private-dropdown m-0">
                                                                        <Dropdown.Toggle
                                                                            id="isprivate"
                                                                            disabled={isViewMode}
                                                                            className="no-appearance"
                                                                            style={
                                                                                item?.rolename === "Workflow Admin"
                                                                                    ? {
                                                                                        background: "#CCF2FF",
                                                                                        borderColor: "#CCF2FF",
                                                                                        color: "#111111",
                                                                                    }
                                                                                    : {
                                                                                        background: "#EEEEEE",
                                                                                        borderColor: "#EEEEEE",
                                                                                        color: "#111111",
                                                                                    }
                                                                            }
                                                                        >
                                                                            {item?.rolename}
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            {roleType?.length > 0 &&
                                                                                roleType?.map((items) => {
                                                                                    return (
                                                                                        <Dropdown.Item
                                                                                            className={
                                                                                                item?.rolename ===
                                                                                                    items?.rolename
                                                                                                    ? "active"
                                                                                                    : ""
                                                                                            }
                                                                                            href="#"
                                                                                            onClick={
                                                                                                (e) =>
                                                                                                    handleUpdateContact(
                                                                                                        item,
                                                                                                        items
                                                                                                    )

                                                                                                // fnInputChange(
                                                                                                //   items?.roleid,
                                                                                                //   item?.userid,
                                                                                                //   "put",
                                                                                                //   item?.workflowteamid
                                                                                                // )
                                                                                            }
                                                                                            key={items?.roleid}
                                                                                        >
                                                                                            <h6>{items?.rolename}</h6>
                                                                                            <p>{items?.details}</p>
                                                                                        </Dropdown.Item>
                                                                                    );
                                                                                })}
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {!isViewMode &&
                                                            Userdata.subscriberid === item?.subscriberid && item?.associationtype === "Subscribers" ? <></> : (
                                                            <img
                                                                src={close}
                                                                alt="close"
                                                                id="description"
                                                                className="cursor-pointer"
                                                                onClick={
                                                                    () => handleDeleteContact(item)
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        );
                                    })}
                            </div>
                            {!isViewMode && (
                                <>
                                    {" "}
                                    {contactData.some(
                                        (machineItem) => !machineItem?.workflowroleid
                                    ) && (
                                            <div>
                                                <Row>
                                                    <Col xl={12}>
                                                        <p className="contact-text-heading">Add Members </p>
                                                    </Col>
                                                </Row>
                                                <div>
                                                    {contactData?.length > 0 &&
                                                        contactData?.map((item, index) => {
                                                            return (
                                                                <>
                                                                    {!item?.workflowroleid && (
                                                                        <div className="d-flex align-items-center justify-content-between contact-detail-in-flow-page-inner-second">
                                                                            <div className="contact-detail-in-flow-page">
                                                                                <div className="contact-detail-in-flow-page-img">
                                                                                    <img
                                                                                        src={
                                                                                            item?.profilepicurl || profileicon
                                                                                        }
                                                                                        alt={item?.contactname}
                                                                                        title={item?.contactname}
                                                                                        key={index}
                                                                                        onError={(e) => {
                                                                                            e.target.onerror = null;
                                                                                            e.target.src = profileicon;
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                                <div className="contact-detail-in-flow-page-detail">
                                                                                    <h5
                                                                                        title={
                                                                                            item?.firstname +
                                                                                            " " +
                                                                                            item?.lastname
                                                                                        }
                                                                                    >
                                                                                        {commonservices.truncateText(
                                                                                            item?.firstname +
                                                                                            " " +
                                                                                            item?.lastname,
                                                                                            20
                                                                                        )}
                                                                                    </h5>
                                                                                </div>
                                                                            </div>
                                                                            {!isViewMode && (
                                                                                <div>
                                                                                    <Dropdown className="public-private-dropdown">
                                                                                        <Dropdown.Toggle
                                                                                            id="isprivate"
                                                                                            disabled={isViewMode}
                                                                                        >
                                                                                            Add
                                                                                        </Dropdown.Toggle>
                                                                                        <Dropdown.Menu>
                                                                                            {roleType?.length > 0 &&
                                                                                                roleType?.map((items) => {
                                                                                                    return (
                                                                                                        <Dropdown.Item
                                                                                                            onClick={
                                                                                                                (e) =>
                                                                                                                    handleAddContact(
                                                                                                                        item,
                                                                                                                        items
                                                                                                                    )
                                                                                                                // fnInputChange(
                                                                                                                //   items?.roleid,
                                                                                                                //   item?.userid,
                                                                                                                //   "add",
                                                                                                                //   item?.workflowteamid,
                                                                                                                //   item?.subscriberscontactid
                                                                                                                // )
                                                                                                            }
                                                                                                            key={items?.roleid}
                                                                                                        >
                                                                                                            <h6>{items?.rolename}</h6>
                                                                                                            <p>{items?.details}</p>
                                                                                                        </Dropdown.Item>
                                                                                                    );
                                                                                                })}
                                                                                        </Dropdown.Menu>
                                                                                    </Dropdown>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        )}
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <Loader type={LoaderType.WorkFlowContacts} count={3} />
                        </>
                    )}
                </>
            </div>

            {DeleteContactModalShow && (
                <DeleteModal
                    requiredData={requiredData}
                    setContactData={setContactData}
                    contactData={contactData}
                    isContactDeleteModelClass={true}
                    payload={DeletePayload}
                    url={API_URL.WORKFLOWTEAM.DELETE}
                    show={DeleteContactModalShow}
                    bindlist={fetchData}
                    onHide={(e) => setDeleteContactModalShow(false)}
                />
            )}
        </Tab.Container>
    );
}

export default WorflowContactList;
